module.exports = __webpack_public_path__ + "static/samora-8b31b51289bbc5b715065265ff99949d.png";